// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R7Xbn0Sh7_cfLoKfaWs9{max-height:100%;padding:0 24px 24px}.xkDvIy4ocCwJb7u3FEDP{padding-left:24px;padding-right:24px}.MmUse4pwsg3uML0gUZjB{padding-top:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"presetUnifiedList": `R7Xbn0Sh7_cfLoKfaWs9`,
	"presetGrid": `xkDvIy4ocCwJb7u3FEDP`,
	"footer": `MmUse4pwsg3uML0gUZjB`
};
export default ___CSS_LOADER_EXPORT___;
